import { z } from 'zod';
export const importEntityTypeSchema = z.enum(['lead', 'opportunity']);
export const importDedupeModeSchema = z.enum(['skip', 'update', 'create_anyway']);
export const importOptionsSchema = z.object({
    dedupeMode: importDedupeModeSchema.default('skip'),
    defaultOwnerId: z.string().uuid().optional(),
    /** Lead imports only. */
    defaultStatusId: z.string().uuid().optional(),
    /** Opportunity imports only — used when a row's own pipeline column is
     * blank or unmapped. */
    defaultPipelineId: z.string().uuid().optional(),
    tag: z.string().trim().max(60).optional(),
});
/** Maps a CSV column header to a target field, or 'skip'. The value enum is
 * the union of every entity's field set — a given job only ever uses the
 * subset for its own `entityType`; the service rejects a mapping outside
 * that subset for the job it was submitted against (the UI only ever
 * offers the matching subset, so this is defense in depth, not the
 * primary guard). */
export const importMappingSchema = z.record(z.string(), z.enum([
    'skip',
    // lead
    'firstName',
    'lastName',
    'email',
    'phone',
    'companyName',
    'jobTitle',
    'website',
    'sourceName',
    'note',
    // opportunity
    'name',
    'amount',
    'currency',
    'pipelineName',
    'stageName',
    'expectedCloseDate',
    'ownerName',
    'contactName',
    'contactEmail',
    'contactTitle',
    'source',
    'status',
]));
export const LEAD_IMPORT_FIELDS = ['firstName', 'lastName', 'email', 'phone', 'companyName', 'jobTitle', 'website', 'sourceName', 'note'];
export const OPPORTUNITY_IMPORT_FIELDS = [
    'name',
    'amount',
    'currency',
    'pipelineName',
    'stageName',
    'companyName',
    'ownerName',
    'expectedCloseDate',
    'contactName',
    'contactEmail',
    'contactTitle',
    'source',
    'status',
    'note',
];
export const commitImportSchema = z.object({
    mapping: importMappingSchema,
    options: importOptionsSchema,
});
export const importJobResponseSchema = z.object({
    id: z.string().uuid(),
    entityType: importEntityTypeSchema,
    fileName: z.string(),
    status: z.enum(['mapping', 'validating', 'ready', 'importing', 'completed', 'failed', 'rolled_back']),
    mapping: importMappingSchema,
    options: importOptionsSchema.partial(),
    counts: z.object({
        total: z.number().int().default(0),
        valid: z.number().int().default(0),
        invalid: z.number().int().default(0),
        duplicate: z.number().int().default(0),
        imported: z.number().int().default(0),
        skipped: z.number().int().default(0),
        updated: z.number().int().default(0),
    }),
    suggestedMapping: z.record(z.string(), z.string()).optional(),
    previewRows: z.array(z.record(z.string(), z.string())).optional(),
    createdAt: z.string().datetime(),
    finishedAt: z.string().datetime().nullable(),
});
export const importRowResponseSchema = z.object({
    rowNumber: z.number().int(),
    raw: z.record(z.string(), z.string()),
    status: z.string(),
    errors: z.array(z.string()).nullable(),
});
export const importJobDetailResponseSchema = importJobResponseSchema.extend({
    errorRows: z.array(importRowResponseSchema),
});
//# sourceMappingURL=schemas.js.map